"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModifySessionInfoSchema = void 0;
const zod_1 = require("zod");
const ModifySessionInfoSchema = zod_1.z.object({
    Id: zod_1.z.number(),
    Name: zod_1.z.string(),
    Date: zod_1.z.date(),
    AnimatorId: zod_1.z.string(),
    DeckId: zod_1.z.number(),
    Language: zod_1.z.string(),
    Comment: zod_1.z.string(),
});
exports.ModifySessionInfoSchema = ModifySessionInfoSchema;
